var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{on:{"click":function($event){return _vm.signIn('google')}}},[_c('img',{staticClass:"signin-img",attrs:{"src":"/img/Google__G__Logo.svg"}}),_vm._v(" "+_vm._s(_vm.signintext)+" with Google ")])}
var staticRenderFns = []

export { render, staticRenderFns }